var React = require('react');

function IconWDrupalInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1842.9,677.1C1638.9,473.1,1368,360,1080,360C485.1,360,0,845.1,0,1440s485.1,1080,1080,1080\n\ts1080-485.1,1080-1080C2160,1152,2046.9,881.1,1842.9,677.1z M1080,2141.1c-325.7,0-591.4-265.7-591.4-591.4\n\tc0-276,185.1-461.1,348-624c108-108,212.6-212.6,243.4-329.1c30.9,116.6,133.7,221.1,243.4,329.1c162.9,162.9,348,348,348,624\n\tC1671.4,1875.4,1405.7,2141.1,1080,2141.1z"}));
}

IconWDrupalInline.defaultProps = {"version":"1.1","viewBox":"0 0 2160 2880"};

module.exports = IconWDrupalInline;

IconWDrupalInline.default = IconWDrupalInline;
